The question this is responding to.
